import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import login from '../assets/images/loginpage.jpg';
import './Auth.css';
import { apiCall } from '../utils/api';
import { toast } from 'react-toastify';

const Login = () => {
  const [formData, setFormData] = useState({
    email: '',
    password: '',
    role: 'teacher' // Default role is teacher
  });
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();

  // Dummy credentials for demo
  const dummyCredentials = {
    admin: {
      email: 'admin@yogakarega.com',
      password: 'admin123'
    },
    teacher: {
      email: 'teacher@yogakarega.com',
      password: 'teacher123'
    },
    user: {
      email: 'user@yogakarega.com',
      password: 'user123'
    }
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.email) {
      newErrors.email = 'Email is required';
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = 'Email is invalid';
    }

    if (!formData.password) {
      newErrors.password = 'Password is required';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validateForm()) {
      try {
        const response = await apiCall('/auth/login', 'POST', {
          email: formData.email,
          password: formData.password,
          role: formData.role
        });

        const { token, user } = response;

        // Store user data in localStorage
        localStorage.setItem('token', token);
        localStorage.setItem('userData', JSON.stringify({
          ...user,
          isLoggedIn: true,
          loginTime: new Date().toISOString()
        }));

        window.dispatchEvent(new Event('authChanged'));

        // Redirect based on role
        toast.success('Login successful!');
        switch (user.role) {
          case 'admin':
            navigate('/admin/dashboard');
            break;
          case 'institution':
            navigate('/institution/dashboard');
            break;
          case 'studio':
            navigate('/studio/dashboard');
            break;
          case 'teacher':
            navigate('/teacher/dashboard');
            break;
          case 'user':
          default:
            navigate('/user/dashboard');
            break;
        }

      } catch (error) {
        toast.error(error.message || 'Login failed');
      }
    }
  };

  return (
    <div className="auth-container" style={{ backgroundImage: `url(${login})`, backgroundSize: 'cover', backgroundPosition: 'center', backgroundRepeat: 'no-repeat' }}>
      <div className="auth-form">
        <h2>Login to Your Account</h2>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Login As</label>
            <select
              name="role"
              value={formData.role}
              onChange={handleChange}
              className={errors.role ? 'error' : ''}
            >
              <option value="teacher">Teacher</option>
              <option value="admin">Admin</option>
            </select>
            {errors.role && <span className="error-message">{errors.role}</span>}
          </div>

          <div className="form-group">
            <label>Email</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              className={errors.email ? 'error' : ''}
            />
            {errors.email && <span className="error-message">{errors.email}</span>}
          </div>

          <div className="form-group">
            <label>Password</label>
            <input
              type="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              className={errors.password ? 'error' : ''}
            />
            {errors.password && <span className="error-message">{errors.password}</span>}
          </div>

          <button type="submit" className="auth-button">Login</button>
        </form>
        <p className="auth-link">
          Don't have an account? <a href="/register">Register here</a>
        </p>
      </div>
    </div>
  );
};

export default Login;
